import React from "react";
import "./BasesConcurso.css"

const CondicionesSorteoPolera = () => {
    return (
        <div className="bases-concurso bases-container">
            <div className="bases-content">
                <header className="bases-header">
                    <h1>Condiciones del sorteo</h1>
                    <h2>Polera oficial del F.C. Barcelona autografiada por Lionel Messi</h2>
                    <h3>Teletón 2026 de UNICEF Bolivia</h3>
                </header>

                <section>
                    <h2>1. Participantes</h2>
                    <p>Podrán participar del sorteo únicamente las personas mayores de 18 años, que realicen una o más donaciones en el marco de la Teletón 2026 de UNICEF Bolivia, conforme a las condiciones establecidas en el presente documento.</p>
                </section>

                <section>
                    <h2>2. Mecánica de participación</h2>
                    <p>Cada donación (a través de la página www.unicef/org.bo/LapoleradeMessi) de Bs. 50 equivale a una opción de participación en el sorteo. Las personas que realicen donaciones por montos superiores acumularán más opciones, de acuerdo con la siguiente equivalencia: por cada Bs. 50 donados, se generará una participación adicional. Por ejemplo: una donación de Bs. 100 equivale a dos opciones; una donación de Bs 150 equivale a tres opciones, y así sucesivamente.</p>
                </section>

                <section>
                    <h2>3. Premio</h2>
                    <p>El premio consiste en una polera oficial del FC Barcelona (temporada 2020 2021) autografiada por Lionel Messi. El premio incluye el certificado de autenticidad correspondiente. El premio es personal, no transferible, no canjeable por dinero en efectivo ni por otro bien o servicio.</p>
                </section>

                <section>
                    <h2>4. Fecha y lugar del sorteo</h2>
                    <p>El sorteo de la polera autografiada se realizará durante la transmisión en vivo de la Teletón 2026 de UNICEF Bolivia, el domingo 20 de septiembre de 2026, desde el escenario principal de la EXPOCRUZ, en la ciudad de Santa Cruz de la Sierra. La Teletón será transmitida a nivel nacional por señal abierta a través de RED UNO y por las redes sociales oficiales habilitadas para el evento.</p>
                </section>

                <section>
                    <h2>5. Selección de la persona ganadora</h2>
                    <p>La persona ganadora será seleccionada de manera aleatoria entre todas las participaciones válidas registradas hasta el momento definido por la organización del sorteo. UNICEF Bolivia podrá verificar que la persona seleccionada cumpla con todos los requisitos establecidos en estas condiciones antes de confirmar la entrega del premio.</p>
                </section>

                <section>
                    <h2>6. Comunicación con la persona ganadora</h2>
                    <p>UNICEF Bolivia se comunicará con la persona ganadora a través de los datos de contacto registrados al momento de realizar la donación. En caso de que no sea posible contactar al ganador dentro del plazo definido por UNICEF Bolivia, o si la persona no cumple con los requisitos establecidos, UNICEF podrá seleccionar a un nuevo ganador.</p>
                </section>

                <section>
                    <h2>7. Entrega del premio</h2>
                    <p>UNICEF Bolivia podrá enviar el premio únicamente a ciudades capitales de Bolivia. En caso de que la persona ganadora resida en una localidad distinta, deberá recoger el premio en una de las ciudades capitales del país, previa coordinación con UNICEF Bolivia.</p>
                </section>

                <section>
                    <h2>8. Recojo del premio</h2>
                    <p>La persona ganadora deberá recoger el premio de manera personal, presentando su documento de identidad vigente. En caso de que no pueda recogerlo personalmente, la persona que lo represente deberá presentar un poder legal suficiente, además de su propio documento de identidad y una copia del documento de identidad del ganador.</p>
                </section>

                <section>
                    <h2>9. Plazo para el recojo</h2>
                    <p>La persona ganadora deberá coordinar y recoger el premio dentro de los 15 días calendario siguientes al sorteo. En caso de que el premio no sea recogido dentro de dicho plazo, UNICEF Bolivia podrá disponer del mismo conforme a los fines de la campaña o realizar una nueva asignación, según corresponda.</p>
                </section>

                <section>
                    <h2>10. Verificación de identidad y datos</h2>
                    <p>Para la entrega del premio, UNICEF Bolivia podrá solicitar la verificación de los datos personales de la persona ganadora, incluyendo nombre completo, número de documento de identidad, ciudad de residencia y datos de contacto. La información será utilizada exclusivamente para fines relacionados con la validación y entrega del premio.</p>
                </section>

                <section>
                    <h2>11. Aceptación del premio</h2>
                    <p>Una vez entregado el premio, no se admitirán cambios, devoluciones, reclamos posteriores ni solicitudes de compensación económica. UNICEF Bolivia no se responsabiliza por daños, pérdida o deterioro del premio una vez realizada la entrega formal a la persona ganadora o a su representante legalmente autorizado.</p>
                </section>

                <section>
                    <h2>12. Uso de imagen y difusión</h2>
                    <p>La persona ganadora autoriza a UNICEF Bolivia a utilizar su nombre, imagen, voz, fotografía o registro audiovisual relacionado con la entrega del premio, únicamente con fines de comunicación, difusión y rendición de cuentas de la Teletón 2026, sin que ello genere derecho a compensación económica alguna.</p>
                </section>

                <section>
                    <h2>13. Exclusiones</h2>
                    <p>No podrán participar del sorteo las personas directamente involucradas en la organización, administración o ejecución del sorteo, ni aquellas que tengan acceso directo al sistema de registro o selección de participantes. Tampoco podrán participar funcionarios de UNICEF ni de RED UNO ni sus familiares de primer grado.</p>
                </section>

                <section>
                    <h2>14. Donaciones válidas</h2>
                    <p>Participarán únicamente las donaciones efectivamente registradas y validadas por los canales oficiales habilitados por UNICEF Bolivia para la Teletón 2026. UNICEF Bolivia podrá excluir participaciones que presenten inconsistencias, datos incompletos, errores de registro, operaciones anuladas o cualquier situación que impida verificar la donación.</p>
                </section>

                <section>
                    <h2>15. Aceptación de las condiciones</h2>
                    <p>La participación en el sorteo implica la aceptación plena de las presentes condiciones. UNICEF Bolivia se reserva el derecho de interpretar, complementar o modificar estas condiciones cuando resulte necesario para garantizar la transparencia, seguridad y correcta ejecución del sorteo.</p>
                </section>

                <section>
                    <h2>16. Transparencia del sorteo</h2>
                    <p>UNICEF Bolivia realizará el sorteo procurando asegurar criterios de transparencia, imparcialidad y trazabilidad en la selección de la persona ganadora, en el marco de la Teletón 2026 y de sus procedimientos internos.</p>
                </section>
            </div>
        </div>
    );
}

export default CondicionesSorteoPolera;
